"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var polished_1 = require("polished");
var React = tslib_1.__importStar(require("react"));
var FormGroupContext_1 = tslib_1.__importDefault(require("../FormGroup/FormGroupContext"));
var styled_components_1 = tslib_1.__importDefault(require("../Themes/styled-components"));
var Button_1 = tslib_1.__importDefault(require("./Button"));
var Icon_1 = tslib_1.__importDefault(require("./Icon"));
var Loading_1 = tslib_1.__importDefault(require("./Loading"));
var Select_1 = tslib_1.__importDefault(require("./Select"));
var utils_1 = require("./utils");
var Input = styled_components_1.default.input(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  flex: 1 0 0;\n  border: 0;\n  font-size: ", ";\n  padding: 0 ", ";\n  height: ", ";\n  color: ", ";\n  font-family: ", ";\n  outline: 0;\n  background-color: ", ";\n  box-shadow: ", ";\n  &::placeholder {\n    color: ", ";\n  }\n  &:read-only {\n    cursor: ", ";\n  }\n  &:disabled {\n    -webkit-text-fill-color: ", ";\n    background-color: ", ";\n    cursor: ", ";\n  }\n"], ["\n  width: 100%;\n  flex: 1 0 0;\n  border: 0;\n  font-size: ", ";\n  padding: 0 ", ";\n  height: ", ";\n  color: ", ";\n  font-family: ", ";\n  outline: 0;\n  background-color: ", ";\n  box-shadow: ", ";\n  &::placeholder {\n    color: ", ";\n  }\n  &:read-only {\n    cursor: ", ";\n  }\n  &:disabled {\n    -webkit-text-fill-color: ", ";\n    background-color: ", ";\n    cursor: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.input.fontSize);
}, function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.input.horizontalPadding);
}, function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.input.height);
}, function (_a) {
    var theme = _a.theme;
    return theme.textColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.input.backgroundColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.input.shadow;
}, function (_a) {
    var theme = _a.theme;
    return theme.form.placeholderColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.input.readOnlyCursor;
}, function (_a) {
    var theme = _a.theme;
    return theme.input.disabledTextColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.input.disabledBackground;
}, function (_a) {
    var theme = _a.theme;
    return theme.input.disabledCursor;
});
var Wrapper = styled_components_1.default('div')(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  border-left: 0;\n  border-right: 0;\n  > * {\n    border-radius: 0;\n  }\n  > ", ", > ", " {\n    border-top: ", ";\n    border-bottom: ", ";\n  }\n  > :first-child {\n    border-left: ", ";\n    border-top-left-radius: ", ";\n    border-bottom-left-radius: ", ";\n    &", " {\n      border-left: ", ";\n    }\n  }\n  > :last-child {\n    border-right: ", ";\n    border-top-right-radius: ", ";\n    border-bottom-right-radius: ", ";\n    &", " {\n      border-right: ", ";\n    }\n  }\n  > ", ", > ", " {\n    border-top: ", ";\n    border-bottom: ", ";\n  }\n  > ", " {\n    border-top: ", ";\n    border-bottom: ", ";\n    padding-right: ", ";\n    background: ", ";\n    select {\n      border: 0;\n      height: 100%;\n      background: transparent;\n      font-size: 13px;\n    }\n  }\n  > ", " {\n    border-left: 0;\n    border-right: 0;\n  }\n"], ["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  border-left: 0;\n  border-right: 0;\n  > * {\n    border-radius: 0;\n  }\n  > ", ", > ", " {\n    border-top: ", ";\n    border-bottom: ", ";\n  }\n  > :first-child {\n    border-left: ", ";\n    border-top-left-radius: ", ";\n    border-bottom-left-radius: ", ";\n    &", " {\n      border-left: ", ";\n    }\n  }\n  > :last-child {\n    border-right: ", ";\n    border-top-right-radius: ", ";\n    border-bottom-right-radius: ", ";\n    &", " {\n      border-right: ", ";\n    }\n  }\n  > ", ", > ", " {\n    border-top: ", ";\n    border-bottom: ", ";\n  }\n  > ", " {\n    border-top: ", ";\n    border-bottom: ", ";\n    padding-right: ", ";\n    background: ", ";\n    select {\n      border: 0;\n      height: 100%;\n      background: transparent;\n      font-size: 13px;\n    }\n  }\n  > ", " {\n    border-left: 0;\n    border-right: 0;\n  }\n"])), Input, Button_1.default, function (props) { return utils_1.getBorderFromProps(props); }, function (props) { return utils_1.getBorderFromProps(props); }, function (props) { return utils_1.getBorderFromProps(props); }, function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.input.borderRadius);
}, function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.input.borderRadius);
}, Button_1.default, function (props) { return utils_1.getBorderFromProps(props); }, function (props) { return utils_1.getBorderFromProps(props); }, function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.input.borderRadius);
}, function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.input.borderRadius);
}, Button_1.default, function (props) { return utils_1.getBorderFromProps(props); }, Icon_1.default, Loading_1.default, function (props) { return utils_1.getBorderFromProps(props); }, function (props) { return utils_1.getBorderFromProps(props); }, Select_1.default, function (props) { return utils_1.getBorderFromProps(props); }, function (props) { return utils_1.getBorderFromProps(props); }, polished_1.rem(5), function (_a) {
    var theme = _a.theme;
    return theme.separatorColor;
}, Button_1.default);
var CompInput = /** @class */ (function (_super) {
    tslib_1.__extends(CompInput, _super);
    function CompInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            focused: false,
        };
        _this.handleFocus = function (event) {
            var onFocus = _this.props.onFocus;
            if (onFocus) {
                onFocus(event);
            }
            _this.setState({ focused: true });
        };
        _this.handleBlur = function (event) {
            var onBlur = _this.props.onBlur;
            if (onBlur) {
                onBlur(event);
            }
            _this.setState({ focused: false });
        };
        return _this;
    }
    CompInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, children = _a.children, restProps = tslib_1.__rest(_a, ["className", "children"]);
        var focused = this.state.focused;
        if (!children) {
            // no children basic input
            return (React.createElement(CompInput, tslib_1.__assign({}, this.props),
                React.createElement("input", null),
                !!this.props.icon && React.createElement(Icon_1.default, { name: this.props.icon }),
                !!this.props.loading && React.createElement(Loading_1.default, null)));
        }
        return (React.createElement(FormGroupContext_1.default.Consumer, null, function (value) { return (React.createElement(Wrapper, { focused: focused, readOnly: !!_this.props.readOnly, error: !!restProps.error }, React.Children.map(children, function (child) {
            if (!child) {
                return child;
            }
            else if (child.type === 'input') {
                return (React.createElement(Input, tslib_1.__assign({}, restProps, { className: className, ref: _this.props.inputRef, onFocus: _this.handleFocus, onBlur: _this.handleBlur, id: _this.props.id || value.id })));
            }
            else if (child.type === Button_1.default ||
                child.type === Icon_1.default ||
                child.type === Loading_1.default ||
                child.type === Select_1.default) {
                return React.cloneElement(child, {
                    error: restProps.error,
                });
            }
            return undefined;
        }))); }));
    };
    CompInput.Button = Button_1.default;
    CompInput.Icon = Icon_1.default;
    CompInput.Loading = Loading_1.default;
    CompInput.Select = Select_1.default;
    return CompInput;
}(React.PureComponent));
exports.default = CompInput;
var templateObject_1, templateObject_2;
